
import React from 'react';
import LandingPage from './Components/LandingPage';
import BookDemo from './Components/BookDemo';

function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
